<template>
    <div>
        <el-tabs v-model="activeTab">
            <el-tab-pane v-for="tab in fieldsData" :label="tab.display_name" :name="tab.name" :key="tab.id">
                <div slot="label">
                    <span @click.stop>
                                     <el-checkbox v-model="tab.checked" class="pr6" :disabled="isView||tab.disabled" @change="val=>changeCurModule(tab,val)" ></el-checkbox>
                                </span>
                    <span :class="[tab.checked?'text-color-primary':'']">{{tab.display_name}}</span>
                </div>
            </el-tab-pane>
        </el-tabs>
        
        <div class="checkbox-content">
            <div class="group-item-1"  v-for="group1 in activeTabGroup" :key="group1.id">
                <div class="group-title mt10 mb10">
                    <el-checkbox
                        :disabled="group1.disabled||isView"
                        v-model="group1.checked"
                        @change="handleCheck(group1, $event)">
                        <span>{{group1.display_name}}</span>
                    </el-checkbox>
                </div>
                <div class="group-content">
                    <template v-for="group2 in group1.children">
                        <el-checkbox
                            class="ml40 mb6"
                            :disabled="group2.disabled||isView||group2.default_check=='1'"
                            v-model="group2.checked"
                            @change="handleCheck(group2, $event)">
                            <span>{{group2.display_name}}</span>
                        </el-checkbox>
                    </template>
                </div>
            </div>
        </div>


        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div class="dialog-footer pt20 tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    export default {
        name: "TabRoleFieldModal",
        props:{
            fields: {
                type: Array,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            isView:{
                type: Boolean,
                required:true,
            },
            actionType:{
                type: String,
                required: true
            },
            cbs:{
                type:Object,
            },
        },
        data(){
            return {
                activeTab:'',
                fieldsData:[],
            }
        },
        computed:{
            activeTabGroup(){
                let fields = this.fieldsData||[];
                if(!this.activeTab) return [];
                let activeTab = fields.find(item=>item.name==this.activeTab)||{};
                return activeTab.children||[];
            },
        },
        watch:{
            fields: {
                handler(new_value) {
                    if(Array.isArray(new_value)&&new_value.length>0){
                        this.fieldsData = this._fmtTreeData(cloneDeep(new_value));
                    }
                    this.fieldsData.forEach(item=>{
                        let children = item.children||[];
                        if(children.some(inner=>inner.checked===true)&&item.checked==false){
                            item.checked = true;
                        }
                    });
                    this.activeTab = this.fieldsData.map(item=>item.name)[0]||'';
                },
                deep: true,
                immediate: true
            }
        },
        methods:{
            handleClose(){
                this.$emit('close');
            },
            changeCurModule(tab,val){
                console.log('changeCurModule',tab,val);
                let groupData = tab.children||[];
                let errArr = [];

                groupData.forEach(item=>{
                    if(item.disabled) return console.log('不可操作',item);
                    this.$set(item,'checked',val);
                    let children = item.children||[];

                    children.forEach(inner=>{
                        if(val===false&&(inner.default_check=='1')){
                            this.$set(inner,'checked',true);
                            this.$set(item,'checked',true);
                            this.$set(tab,'checked',true);
                            if(inner.default_check=='1'){
                                errArr.push(inner);
                            }
                        }else{
                            if(!inner.disabled){
                                this.$set(inner,'checked',val);
                            }
                        }
                    })
                });
                if(errArr.length>0){
                    let nameStr = errArr.map(item=>item.display_name).join('、');
                    this.$message.error('【'+nameStr+'】字段为必选项');
                }
            },
            handleSubmit() {
                let actionIds = this._getCheckedVal(this.fieldsData,[]);
                this.cbs.onSubmit({
                    page:this.page,
                    actionIds,
                });
                this.handleClose();
            },
            handleCheck(data,val){
                console.log('handleCheck',data,val);
                let isParent = data.children&&data.children.length>0;
                let parentNode = this._findModuleById(this.fieldsData,data.pid);
                let rootNode = this._findModuleById(this.fieldsData,parentNode.pid);
                let errArr = [];
                if(isParent){
                    // 父级
                    let children = data.children;
                    children.forEach(item=>{
                        if(val===false&&(item.default_check=='1')){
                            this.$set(item,'checked',true);
                            this.$set(data,'checked',true);
                            if(item.default_check=='1'){
                                errArr.push(item);
                            }
                        }else{
                            if(!item.disabled){
                                this.$set(item,'checked',val);
                            }
                        }
                    });
                    if(val){
                        if(parentNode.checked==false){
                            this.$set(parentNode,'checked',true);
                        }
                    }else{
                        if(parentNode.children.every(item=>item.checked==false)){
                            this.$set(parentNode,'checked',false);
                        }
                    }
                }else{
                    console.log(1111,data);
                    // 子级
                    if(data.default_check=='1'){
                        errArr.push(data);
                        this.$set(data,'checked',true);
                    }else{
                        if(parentNode){
                            if(val){
                                this.$set(parentNode,'checked',true);
                                if(rootNode&&rootNode.checked===false){
                                    this.$set(rootNode,'checked',true);
                                }
                            }else{
                                if(parentNode.children.every(item=>item.checked==false)){
                                    this.$set(parentNode,'checked',false);
                                }
                                if(rootNode.children.every(item=>item.checked==false)){
                                    this.$set(rootNode,'checked',false);
                                }
                            }
                        }
                    }
                }

                if(errArr.length>0){
                    let nameStr = errArr.map(item=>item.display_name).join('、');
                    this.$message.error('【'+nameStr+'】字段为必选项');
                }
            },

            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    if(v.disabled) return console.log('v.disabled',v.disabled);
                    if(v.default_check==='1'){
                        /* 如果当前是必选项，则默认选中 */
                        this.$set(v,'checked',true);
                    }
                    let childFields = v.children||[];
                    if (childFields.length > 0) {
                        if(childFields.some(item=>item.checked===true||item.default_check==='1')){
                            /* 如果子级里有已选中，则父级需要选中 */
                            this.$set(v,'checked',true);
                        }
                        this._fmtTreeData(childFields);
                    }
                });
                return data;
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        return this._getCheckedVal(item.children,result);
                    }
                });
                return result;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .checkbox-content{
        max-height: 500px;
        overflow-y: auto;
        padding-left: 20px;
        padding-right: 20px;
    }
    .dialog-footer{
        padding-top: 20px;
    }
</style>
